var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vant-field-attachment"},[_c('van-field',{style:(_vm.cellStyle),attrs:{"label":_vm.label,"required":_vm.required,"readonly":_vm.readonly,"placeholder":_vm.placeholder,"type":"textarea","autosize":""},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }